/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} _Field_MembershipInputs */

const de__field_membership = /** @type {(inputs: _Field_MembershipInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Mitgliedschaft`)
};

/**

* @param {_Field_MembershipInputs} inputs
* @param {{ locale?: "de" }} options
* @returns {LocalizedString}
*/
export const _field_membership = /** @type {((inputs?: _Field_MembershipInputs, options?: { locale?: "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<_Field_MembershipInputs, { locale?: "de" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return de__field_membership(inputs)
});